<template>
  <div id="INIT">
    <v-container fill-height>
      <v-layout row wrap align-center>
        <v-flex xs4 />
        <v-flex xs4>
          <v-flex xs12 class="text-xs-center">
            <img src="static/images/logos/EW_LOGO.png" width="250">
          </v-flex>
          <v-flex xs12>
            <v-progress-linear :indeterminate="true" color="info" height="8" />
          </v-flex>
        </v-flex>
        <v-flex xs4 />
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  }
};
</script>

<style>
#INIT {
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden !important;
}

.input-group__details {
  min-height: 5px !important;
}

.input-group__details:before {
  height: 5px !important;
}

.input-group__details:after {
  height: 5px !important;
}

.input-group--text-field input,
.input-group--text-field textarea {
  font-size: 55px;
  height: 65px;
  text-align: center;
}

.btnPOS {
  margin-top: 60px;
}
</style>





// WEBPACK FOOTER //
// src/components/Loading.vue